const scrollDownIconTop = document.querySelector("[data-scroll-down-icon-top]");
const scrollDownIconBottom = document.querySelector("[data-scroll-down-icon-bottom]");
const scrollDownText = document.querySelector("[data-scroll-down-text]");
let aboutTitleElement = document.querySelector("[data-about-title]");
let aboutTitleDistanceToTop = window.pageYOffset + aboutTitleElement.getBoundingClientRect().top;
let scrollTextElement = document.querySelector(".scroll-text");
let scrollTextDistanceToTop = window.pageYOffset + scrollTextElement.getBoundingClientRect().top;
let pxToScroll = aboutTitleDistanceToTop - scrollTextDistanceToTop;
window.addEventListener("resize", (e)=>{
    aboutTitleDistanceToTop = window.pageYOffset + aboutTitleElement.getBoundingClientRect().top;
    scrollTextDistanceToTop = window.pageYOffset + scrollTextElement.getBoundingClientRect().top;
    pxToScroll = aboutTitleDistanceToTop - scrollTextDistanceToTop;
});
window.addEventListener("scroll", (e)=>{
    let scrollOffset = window.pageYOffset;
    scrollDownIconTop.style.transform = `translateY(${scrollOffset}px) rotate(-45deg)`;
    scrollDownText.style.opacity = -scrollOffset / 75 + 1;
    if (scrollOffset >= pxToScroll) {
        scrollDownIconTop.classList.add("visibility-hidden");
        scrollDownIconBottom.classList.remove("visibility-hidden");
    } else {
        scrollDownIconTop.classList.remove("visibility-hidden");
        scrollDownIconBottom.classList.add("visibility-hidden");
    }
});
const backToTopIcons = [
    ...document.querySelectorAll("[data-back-to-top-icon]")
];
backToTopIcons.forEach((icon)=>{
    icon.addEventListener("click", (e)=>{
        window.scroll({
            top: 0,
            behavior: "smooth"
        });
    });
});
const projects = document.querySelectorAll(".project-container");
const sectionTitles = document.querySelectorAll(".section-title");
const contactForm = document.querySelector(".contact-form");
const observerOptions = {
    threshold: 0.1
};
const infiniteObserver = new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
        entry.target.classList.toggle("show", entry.isIntersecting);
    });
}, observerOptions);
[
    ...sectionTitles
].forEach((title)=>{
    infiniteObserver.observe(title);
});
// [...projects].forEach((project) => {
//   infiniteObserver.observe(project);
// });
const observer = new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
        entry.target.classList.toggle("show", entry.isIntersecting);
        if (entry.isIntersecting) observer.unobserve(entry.target);
    });
}, observerOptions);
observer.observe(contactForm);
[
    ...projects
].forEach((project)=>{
    observer.observe(project);
});
const copyEmailElement = document.querySelector("[data-copy-email]");
copyEmailElement.addEventListener("click", (e)=>{
    e.preventDefault();
    copyEmailToClipboard();
    changeTooltipColor();
});
copyEmailElement.addEventListener("mouseover", (e)=>{
    copyEmailElement.dataset.tooltip = "click to copy email address";
});
function copyEmailToClipboard() {
    const emailAddress = "pranshukumar1999@gmail.com";
    navigator.clipboard.writeText(emailAddress);
    copyEmailElement.dataset.tooltip = `'${emailAddress}' copied to clipboard`;
}
function changeTooltipColor() {
    const rootElement = document.querySelector(":root");
    rootElement.style.setProperty("--tooltip-color", "#999");
    setTimeout(()=>{
        rootElement.style.setProperty("--tooltip-color", "#333");
    }, 150);
}
// Dark Mode Toggle Functionality
const toggleSwitch = document.querySelector("#checkbox");
const currentTheme = localStorage.getItem("theme") || "dark";
// Apply theme (either from localStorage or dark by default)
document.documentElement.setAttribute("data-theme", currentTheme);
// Make sure toggle switch position matches the theme
if (currentTheme === "dark") toggleSwitch.checked = true;
// Function that will switch the theme based on the toggle
function switchTheme(e) {
    if (e.target.checked) {
        document.documentElement.setAttribute("data-theme", "dark");
        localStorage.setItem("theme", "dark");
    } else {
        document.documentElement.setAttribute("data-theme", "light");
        localStorage.setItem("theme", "light");
    }
}
// Event listener for toggle switch
toggleSwitch.addEventListener("change", switchTheme, false);

//# sourceMappingURL=path0.e51f9810.js.map
